<template>
    <div class="right_title">
        <div class="tag">
            <span>{{ title }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        title:String
    }
};
</script>
<style scoped>
</style>